const toMavLink = (fences) => {
  if (!fences) return [];

  const messages = [];
  let currentSeq = 0;

  fences
    .filter(({ type }) => type === 'Polygon')
    .forEach((fence) => {
      const totalVertexCount = fence.data.boundary.length;

      fence.data.boundary.forEach((vertex) => {
        messages.push([
          currentSeq++,
          0, // MAV_FRAME_GLOBAL
          5002, // MAV_CMD_NAV_FENCE_POLYGON_VERTEX_EXCLUSION
          messages.length === 0 ? 1 : 0, // current
          0, // autocontinue
          totalVertexCount,
          0, // param2
          0, // param3
          0, // param4
          vertex.lat * 1e7, // x
          vertex.lng * 1e7, // y
          0, // z
        ]);
      });
    });

  fences
    .filter(({ type }) => type === 'Circle')
    .forEach((fence) => {
      messages.push([
        currentSeq++,
        0, // MAV_FRAME_GLOBAL
        5004, // MAV_CMD_NAV_FENCE_CIRCLE_EXCLUSION
        messages.length === 0 ? 1 : 0, // current
        0, // autocontinue
        fence.data.radius,
        0, // param2
        0, // param3
        0, // param4
        fence.data.center.lat * 1e7, // x
        fence.data.center.lng * 1e7, // y
        0, // z
      ]);
    });

  return messages;
};

const fromMavLink = (messages) => {
  // messages가 빈 배열인 경우
  if (messages.length === 0) return [];

  const fences = [];
  let vertices = [];
  let totalVertexCount = 0;

  messages.forEach((message, index) => {
    // 5004: MAV_CMD_NAV_FENCE_CIRCLE_EXCLUSION
    if (message.command === 5004) {
      fences.push({
        id: index,
        type: 'Circle',
        data: {
          name: '',
          center: {
            lat: message.x / 1e7,
            lng: message.y / 1e7,
          },
          radius: message.param1,
        },
      });
    }
    // 5002: MAV_CMD_NAV_FENCE_POLYGON_VERTEX_EXCLUSION
    else if (message.command === 5002) {
      if (vertices.length === 0) {
        totalVertexCount = message.param1;
      }

      vertices.push({
        lat: message.x / 1e7,
        lng: message.y / 1e7,
      });

      // Polygon 완성 시
      if (vertices.length === totalVertexCount) {
        fences.push({
          id: index,
          type: 'Polygon',
          data: {
            name: '',
            boundary: [...vertices],
          },
        });

        vertices = [];
        totalVertexCount = 0;
      }
    }
  });

  return fences;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { toMavLink, fromMavLink };
